import { render, staticRenderFns } from "./SumFieldSelectBox.vue?vue&type=template&id=32154491&"
import script from "./SumFieldSelectBox.vue?vue&type=script&lang=js&"
export * from "./SumFieldSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports